export default __webpack_public_path__ + "static/media/keycard-laax@4x.06b89249.png";